function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const BASE_URL = '/credit-note';
export class CreditNoteSettingsAPIClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getSettingsConfiguration", ()=>this.get(`${BASE_URL}/configuration`)), _define_property(this, "updateSettingsConfiguration", (payload)=>this.put(`${BASE_URL}/configuration`, payload)), _define_property(this, "getCreditNoteReasons", ()=>this.get(`${BASE_URL}/reasons`)), _define_property(this, "createCreditNoteReason", (payload)=>this.post(`${BASE_URL}/reasons`, payload)), _define_property(this, "updateCreditNoteReason", (reasonId, payload)=>this.put(`${BASE_URL}/reasons/${reasonId}`, payload)), _define_property(this, "deleteCreditNoteReason", (reasonId)=>this.delete(`${BASE_URL}/reasons/${reasonId}`));
    }
}
export const CreditNoteSettingsAPI = new CreditNoteSettingsAPIClient();
